export default __webpack_public_path__ + "static/media/total-countries.bfc3b011.png";